// extracted by mini-css-extract-plugin
export var changeIcon = "_4j-4";
export var container = "_4j-0";
export var divider = "_4j-7";
export var externalLinkIcon = "_4j-1";
export var green = "_4j-5";
export var helpCircleIcon = "_4j-3";
export var iconButton = "_4j-2";
export var red = "_4j-6";